module.exports = __webpack_public_path__ + "media/images/affiliates/feature-3-2b98160485247d011fefa771cb5e3669.jpg";